// Get a reference to the canvas and the toolbar
const canvasElement = document.getElementById('canvas');
const canvas = new fabric.Canvas(canvasElement, {
  width: canvasElement.width,
  height: canvasElement.height,
  backgroundColor: '#101010',
});
const toolbar = document.getElementById('toolbar');

// Get references to the toolbar buttons
const panBtn = document.getElementById('pan-btn');
const editBtn = document.getElementById('edit-btn');
const colorPickerElement = document.getElementById('color-picker');
const drawBtn = document.getElementById('draw-btn');
const eraseBtn = document.getElementById('erase-btn');
const textBtn = document.getElementById('text-btn');
const deleteBtn = document.getElementById('delete-btn');
const objectSizeSlider = document.getElementById('object-size');
const submitBtn = document.getElementById('submit-btn');
const undoBtn = document.getElementById('undo-btn');
const redoBtn = document.getElementById('redo-btn');
const clearBtn = document.getElementById('clear-btn');

let color = colorPickerElement.value;

// Create an array to store the history of actions performed on the canvas
var actionHistory = [];
var isRedoing = false;

// Add an event listener to the canvas to record actions performed on it
canvas.on('object:added',function(){
  if(!isRedoing){
    h = [];
  }
  isRedoing = false;
});

canvas.on('object:modified', () => {
  if (!isRedoing) {
    h = [];
  }
  isRedoing = false;
});

// Add click event listeners to the toolbar buttons
panBtn.addEventListener('click', () => {
  // Set pan mode when the pan button is clicked
  canvas.isDrawingMode = false;
  canvas.selection = false;
  canvas.defaultCursor = 'move';
});

editBtn.addEventListener('click', () => {
  // Set edit mode when the edit button is clicked
  canvas.isDrawingMode = false;
  canvas.selection = true;
  canvas.defaultCursor = 'default';

  // Deselect any selected objects when the edit button is clicked
  canvas.discardActiveObject();

  // Set objects to editable when the edit button is clicked
  canvas.forEachObject((object) => {
    object.set('editable', true);
  });

  // Set objects to not editable when a different toolbar button is clicked unless it is a text object
  toolbar.addEventListener('click', () => {
    canvas.forEachObject((object) => {
      if (!(object instanceof fabric.Text)) {
        object.set('editable', false);
      }
    });
  });

  canvas.on('mouse:down', (e) => {
    // Set objects to editable when they are clicked
    if (e.target) {
      e.target.set('editable', true);
    }
  });
});

// Add a change event listener to the color picker
colorPickerElement.addEventListener('change', (e) => {
  // Set the color to the selected color when the color picker is changed
  color = e.target.value;
  canvas.freeDrawingBrush.color = color;

  // Set the color of the selected object to the selected color
  const selectedObject = canvas.getActiveObject();
  if (selectedObject) {
    let oldStroke = selectedObject.get('stroke');
    let oldFill = selectedObject.get('fill');
    selectedObject.set('stroke', color);
    canvas.requestRenderAll();

    // Set fill color if object is fabric.Text
    if (selectedObject instanceof fabric.Text) {
      selectedObject.set('fill', color);
      canvas.requestRenderAll();
    }
  }
});

drawBtn.addEventListener('click', () => {
  // Set draw mode when the draw button is clicked
  canvas.freeDrawingBrush = new fabric.PencilBrush(canvas);
  canvas.isDrawingMode = true;
  canvas.selection = false;
  canvas.defaultCursor = 'crosshair';

  // Deselect any selected objects when the draw button is clicked
  canvas.discardActiveObject();

  canvas.on('mouse:down', () => {
    // Set the color of the brush to the selected color
    canvas.freeDrawingBrush.color = color;
  });


});

// Add a click event listener to the erase button
eraseBtn.addEventListener('click', () => {
  // Set erase mode when the erase button is clicked
  canvas.freeDrawingBrush = new fabric.EraserBrush(canvas);
  canvas.isDrawingMode = true;
  canvas.selection = false;
  canvas.defaultCursor = 'crosshair';
  canvas.freeDrawingBrush.width = parseInt(objectSizeSlider.value);
});

textBtn.addEventListener('click', () => {
  // Set text mode when the text button is clicked
  canvas.isDrawingMode = false;
  canvas.selection = true;
  canvas.defaultCursor = 'text';

  // Deselect any selected objects when the text button is clicked
  canvas.discardActiveObject();

  // Add text object
  const text = new fabric.IText('Text', {
    left: 100,
    top: 100,
    fontSize: parseFloat(objectSizeSlider.value),
  });

  canvas.add(text);
  canvas.setActiveObject(text);
  canvas.requestRenderAll();
  text.enterEditing();
  text.selectAll();
});

// Update the brush size as the user moves the slider
objectSizeSlider.addEventListener('input', () => {
  // Set the brush size based on the slider value as an integer
  canvas.freeDrawingBrush.width = parseInt(objectSizeSlider.value, 10);
  
  // Set the size of the selected object based on the slider value
  const selectedObject = canvas.getActiveObject();
  if (selectedObject) {
    // Check if object is a brush stroke
    if (selectedObject.get('strokeWidth')) {
      selectedObject.set('strokeWidth', parseInt(objectSizeSlider.value, 10));
      canvas.requestRenderAll();
    }

    // Check if object was a text object
    if (selectedObject instanceof fabric.IText) {
      selectedObject.set('fontSize', parseInt(objectSizeSlider.value, 10));
      canvas.requestRenderAll();
    }
    
  }
});

// Add an event listener for the delete button
deleteBtn.addEventListener('click', () => {
  // Get all selected objects on the canvas
  const selectedObjects = canvas.getActiveObjects();

  // Remove all selected objects from the canvas
  selectedObjects.forEach((object) => {
    canvas.remove(object);
  });

  // Clear the selection
  canvas.discardActiveObject();
});

// Add an event listener for the submit button
submitBtn.addEventListener('click', () => {
  // Convert the canvas to a transparent PNG and open it in a new tab
  canvasElement.toBlob((blob) => {
    const url = URL.createObjectURL(blob);
    console.log("Exporting image")
    window.open(url);
  });
});

// Add a click event listener to the undo button
undoBtn.addEventListener('click', () => {
  if(canvas._objects.length>0){
    h.push(canvas._objects.pop());
    canvas.renderAll();
  }
});

redoBtn.addEventListener('click', () => {
  if(h.length>0){
    isRedoing = true;
   canvas.add(h.pop());
  }
});

// Add a click event listener to the clear button
clearBtn.addEventListener('click', () => {
  // Clear the canvas
  canvas.clear();

  // Clear the action history
  actionHistory.length = 0;

  // Set default mode to draw
  drawBtn.click();
  canvas.freeDrawingBrush.width = parseInt(objectSizeSlider.value, 10);
});

// Click the clear button to clear the canvas on page load
clearBtn.click();